import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicFieldConfig } from '../../dynamic-form/form-config.model';
import { DynamicFormComponent } from '../../dynamic-form/dynamic-form.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-popup',
  imports: [CommonModule, DynamicFormComponent, TranslatePipe],
  templateUrl: './popup.html',
  styleUrls: ['./popup.css'],
  // `title` is an @Input (a translation key), but Angular also leaves it as a native HTML `title`
  // attribute on the host, which shows the raw key as a browser tooltip when hovering the popup.
  host: { '[attr.title]': 'null' },
})
export class Popup {
  @Input() show = false;
  @Input() title = 'COMMON.MODAL_TITLE';
  @Input() width = 'w-full max-w-3xl min-w-[300px]';

  @Input() fields: DynamicFieldConfig[] = [];
  @Input() type: 'form' | 'custom' | 'confirm' = 'form';

  @Input() data: any = {};

  @Input() message = 'COMMON.ARE_YOU_SURE';
  @Input() confirmText = 'COMMON.YES';
  @Input() cancelText = 'COMMON.NO';
  @Input() saveButtonText = 'COMMON.SAVE';
  @Input() mode: 'add' | 'edit' | 'view' = 'add';
  /** Return `false` to keep the popup open (e.g. a validation failed or a save is still in flight). */
  @Input() onSave: (data: any) => unknown = () => {};
  @Input() readonly = false;
  @Input() showFileDownload = true;
  @Input() saveLabel: string | null = null;
  @Input() closeLabel: string | null = null;
  @Input() showCustomFooter = false;

  /** Optional Save button shown alongside the Cancel button for `type: 'custom'` popups. */
  @Input() primaryButtonText: string | null = null;
  @Input() primaryButtonDisabled = false;

  @Output() showChange = new EventEmitter<boolean>();
  @Output() formChange = new EventEmitter<any>();
  @Output() confirmed = new EventEmitter<void>();
  @Output() formSubmit = new EventEmitter<any>();

  /** Emitted when the custom-footer Save button is clicked. Does not auto-close the popup. */
  @Output() primaryClick = new EventEmitter<void>();
  

  // Fixed warning
  @ViewChild(DynamicFormComponent, { static: false })
  dynamicForm!: DynamicFormComponent;

  close(): void {
    this.show = false;
    this.showChange.emit(false);
  }

  triggerSubmit(): void {
    this.dynamicForm?.submit();
  }

  onFormSubmit(formData: any): void {
    if (this.onSave(formData) === false) {
      return;
    }

    this.formSubmit.emit(formData);

    this.close();
  }
  

  onConfirm(): void {
    this.confirmed.emit();
    this.close();
  }
}
